import { Box, Text } from 'grommet';
import styled from 'styled-components';
import { colors } from '../../themes/default.theme';
import { styledButtonProps } from './QuotesInfo';

export const StyledQuotesBox = styled(Box)`
  width: 100%;
`;

export const Data = styled.li`
  display: flex;
  justify-content: center;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 10px;
  background-color: #f5f7fa;
  word-break: break-word;
  &:nth-child(1) {
    width: 19%;
    max-width: 273px;
  }
  &:nth-child(2) {
    width: 12%;
    max-width: 186px;
  }
  &:nth-child(3) {
    width: 8%;
    max-width: 126px;
  }
  &:nth-child(4) {
    width: 9%;
    max-width: 126px;
  }
  &:nth-child(5) {
    width: 9%;
    max-width: 126px;
  }
  &:nth-child(6) {
    width: 9%;
  }
  &:nth-child(7) {
    width: 10%;
  }
  &:nth-child(8) {
    width: 10%;
  }
`;

export const DataText = styled(Text)`
  font-size: 14px;
  font-family: 'PT Sans', sans-serif;
  font-weight: 700;
`;

export const OuterBox = styled.div`
  &:hover {
    box-shadow: inset 4px 0 0 #9325b2;
  }
`;

export const DataGroup = styled.section`
  display: flex;
  flex-direction: row;
  padding: 10px 0;
`;

export const TextData = styled.li`
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    height: 100%;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  color: #041e41;
  font-family: 'PT Sans', sans-serif;
  font-size: 16px;
  font-weight: 400;
  list-style: none;
  margin: 0;
  padding: 10px;
  word-break: break-all;
  &:nth-child(1) {
    width: 2%;
  }
  &:nth-child(2) {
    width: 15%;
  }
  &:nth-child(3) {
    width: 12%;
  }
  &:nth-child(4) {
    width: 8%;
  }
  &:nth-child(5) {
    width: 9%;
  }
  &:nth-child(6) {
    width: 9%;
  }
  &:nth-child(7) {
    width: 9%;
  }
  &:nth-child(8) {
    width: 10%;
    display: flex;
    justify-content: center;
  }
  &:last-child {
    width: 10%;
    display: flex;
    justify-content: center;
  }
`;

export const BorderedBox = styled(Box)`
  border-bottom: 4px solid #65a100;
`;

export const ContinueButton = styled.button<styledButtonProps>`
cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
background-color: #ffffff;
color: ${props => (props.disabled ? '#bdbdbd' : colors.darkBlue2)};
border: 1px solid;
padding: 7px 10px;
border-radius: 3px;
font-size: 14px;
font-weight: bold;
`;

export const WithdrawButton = styled.button<styledButtonProps>`
cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
background-color: #ffffff;
color: ${props => (props.disabled ? '#bdbdbd' : colors.valueRed1)};
border: 1px solid;
padding: 7px 10px;
border-radius: 3px;
font-size: 14px;
font-weight: bold;
`;

export const OuterBoxx = styled.div`
  text-align: center;
`;

export const BigBoldText = styled.p`
  font-size: 24px;
  font-weight: 700;
  margin-top: 45px;
`;

export const SmallText = styled.p`
  font-size: 18px;
  margin-top: 15px;
  margin-bottom: 30px;
`;

export const ErrorBox = styled.div`
  display: flex;
  justify-content: center;
`;

export const LoaderContainer = styled.div`
  padding: 20px;
`;

export const LoadingIcon = styled.img`
  display: block;
  margin: auto;
`;